import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Home() {
    const { t } = useTranslation();
    return (
        <Box sx={{ p:3 }}>
            <Typography variant='h2' sx={{ color: 'primary.main', textAlign: 'left' }}>{t('home.title')}</Typography>
            <Paper elevation={4} sx={{ p: 2, mt: 2, textAlign: 'left' }}>
                {t('home.announcement')}
            </Paper>
        </Box>
    );
}

export default Home;